import React, { useState } from 'react'
import FormatPrice from '../Helpers/FormatPrice'
import CartQuantityToggle from './CartQuantity'
import { FaTrashAlt } from "react-icons/fa";
import { useCartContext } from '../context/cart_context';


const CartItem = ({ SKU, Item, main, price, quantity }) => {
const { removeItem, setDecrease, setIncrease, updateQuantity } = useCartContext();
  
    return (
<tr>
      {/* Item */}
      <td data-label="Item">
        <div className="cart-item-info">
          <img
            src={main || "/images/default.png"}
            alt={Item}
            className="cart-item-img"
            onError={(e) => (e.target.src = "/images/default.png")}
          />
          <p>{SKU} {Item}</p>
          

        </div>
      </td>

      {/* Price */}
      <td data-label="Price">
        <FormatPrice price={price} />
      </td>

      {/* Quantity */}
      <td data-label="Quantity" >
        <CartQuantityToggle
          quantity={quantity}
          setDecrease={() => setDecrease(SKU)}
          setIncrease={() => setIncrease(SKU)}
          updateQuantity={(newQty) => updateQuantity(SKU, newQty)}
        />
      </td>

      {/* Subtotal */}
      <td data-label="Subtotal">
        <FormatPrice price={price * quantity} />
      </td>

      {/* Remove */}
      <td data-label="Remove">
        <FaTrashAlt
          className="remove_icon"
          onClick={() => removeItem(SKU)}
          style={{ cursor: "pointer", color: "red" }}
        />
      </td>
    </tr>
  );
};

export default CartItem;
